import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(chat)/page.tsx");
